<template>
  <div class="main-container">
    <Header></Header>
    <notify></notify>
    <MainContainer></MainContainer>
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from './components/header';
  import MainContainer from './components/main-container';
  import Footer from './components/footer';
  import Notify from './components/notify';

  export default {
    name: 'App',
    components: {
      Notify,
      Footer,
      MainContainer,
      Header
    }
  };
</script>

<style>
    html, body {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        font-family: 'Sarabun', monospace;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        background: #fdfdfd;
    }

    .main-container {
        width: 100%;
        height: 100%;
        display: flex;
        flex-flow: column;
    }
</style>
